export const PROPERTYME_EMAIL_TEMPLATE = {
  to: 'hello@propertyme.com',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello PropertyMe

Could you please enable Snug as an upload destination for our agency for the PropertyMe Account(s):

- [Enter your Agency ID here]

Please assign the PropertyMe Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
